import { useEffect, useState } from "react";
import { Snackbar } from "../../components/Snackbar";
import { DEFAULT_SNACKBAR, ERROR_CREDENTIALS, ERROR_EMPTY_CREDENTIALS, SUCCESS_CREDENTIALS } from "../../utils/snackbar";
import { DEFAULT_CREDENTIALS } from "../../utils/state";
import { useNavigate } from "react-router-dom";
import { useMoodleV2 } from "../../contexts/moodle";
import { useAuth } from "../../contexts/AuthContext";
import { defaultHandleChange } from "../../utils/handler";
import { useConfig } from "../../contexts/config";
import LoginFormV2 from "../../components/LoginForm";
import ForgotPasswordForm from "../../components/LoginForm/ForgotPasswordForm";
import { useTheme } from "../../contexts/ThemeContext";
import "./styles.css";
import { readableColor } from "polished";
import ForcePasswordChangeForm from "../../components/LoginForm/ForcePasswordChangeForm";
import StatsSection from "../../components/LoginCounter";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";

const Login = () => {
  const [snackbar, setSnackbar] = useState(DEFAULT_SNACKBAR);
  const [credentials, setCredentials] = useState(DEFAULT_CREDENTIALS);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const auth = useAuth();
  const navigate = useNavigate();
  const moodlev2 = useMoodleV2();
  const { config } = useConfig();
  const [showForcePasswordChange, setShowForcePasswordChange] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    auth.logout(moodlev2);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    moodlev2.setPageEmbed(null);
  }, [moodlev2]);

  useEffect(() => {
    //console.log(config);
    document.querySelector("#root").style.backgroundColor = "transparent";
    let bg_img = config.config.theme.background_login;
    document.querySelector("#root").classList.add("imagen2", "bigDesktop:bg-cover", "not-laptop:bg-left");
    // if (localStorage.getItem("token")) navigate("/listcourses");

    if (bg_img) {
      console.log(bg_img);
      document.querySelector("#root").style.backgroundImage = `url(${bg_img})`;
    }
    return () => {
      document.querySelector("#root").style.backgroundImage = ``;
      document.querySelector("#root").classList.remove("imagen2", "bg-auto", "bigDesktop:bg-cover");
    };
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(credentials).some((value) => value === "");
    if (isEmpty) {
      setSnackbar(ERROR_EMPTY_CREDENTIALS);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
      return;
    }
    let clean_username = credentials.username.replace(/\s/g, "").toLowerCase();
    // Si username y password son iguales, mostrar el formulario de cambio
    /* if (clean_username === credentials.password && clean_username !== "tipddyalumno") {
    setShowForcePasswordChange(true);
    return;
  } */

    try {
      setLoading(true);
      await auth.Login({ ...credentials, username: clean_username });
      setSnackbar(SUCCESS_CREDENTIALS);
      setTimeout(() => {
        setLoading(false);
        setSnackbar(DEFAULT_SNACKBAR);
        setCredentials(DEFAULT_CREDENTIALS);
        document.body.classList.remove("imagen3");
        navigate("/listcourses");
      }, 1000);
    } catch (error) {
      console.log(error.message);
      setSnackbar(ERROR_CREDENTIALS);
      setLoading(false);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
    }
  };

  const handleDarkMode = () => {
    theme.actions.handleDarkMode();
  };

  const handleChange = (e) => defaultHandleChange(e, credentials, setCredentials);

  console.log(theme);

  return (
    <div className="w-full h-screen  flex items-center justify-center relative overflow-hidden">
      {/* Dark Mode Toggle Button */}
      <div
        onClick={handleDarkMode}
        className="absolute top-4 right-4 z-50 cursor-pointer p-3 rounded-full transition-all duration-300 hover:scale-110"
        style={{
          backgroundColor: theme?.mode === "light" ? "#f5f5f5" : "#333",
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        }}
      >
        {theme?.mode === "light" ? <LightModeIcon sx={{ fontSize: 24, fill: "#2d4662" }} /> : <DarkModeIcon sx={{ fontSize: 24, fill: "#fff" }} />}
      </div>

      {/* Main Container */}
      <div className="z-10 w-full  mx-auto px-4 laptop:px-8">
        <div className="grid grid-cols-1 laptop:grid-cols-12 gap-8 laptop:gap-12 items-center min-h-[90vh]">
          {/* Left Column - Login Form */}
          <div className="laptop:col-span-6 flex justify-center">
            <div className="relative w-full max-w-[39rem]">
              {/* Form Container */}
              <div
                className={`relative bg-gradient-to-br from-[${theme?.colors.tertiary_dark || "#8C7FC8"}] to-[${
                  theme?.colors.text_login_light || "#7B6BC6"
                }] p-1 rounded-3xl`}
              >
                <img
                  className="h-full w-[65%] object-contain m-auto mb-4"
                  src={theme && theme.mode === "light" ? config.config.theme.theme_logo_dark : config.config.theme.theme_logo_dark}
                  alt="..."
                />
                <div
                  style={{
                    backgroundColor: theme && theme.mode === "light" ? "#fff" : theme.colors.primary_light,
                  }}
                  className=" rounded-[1.4rem] p-2 tablet:p-8 shadow-2xl"
                >
                  {/* Login Form */}
                  {!showForgotPassword && !showForcePasswordChange && (
                    <LoginFormV2
                      handleChange={handleChange}
                      credentials={credentials}
                      handleSubmit={handleSubmit}
                      loading={loading}
                      setShowForgotPassword={setShowForgotPassword}
                      theme={theme}
                    />
                  )}

                  {/* Forgot Password Form */}
                  {(showForgotPassword || showForcePasswordChange) && (
                    <ForgotPasswordForm
                      onBackToLogin={() => {
                        setShowForgotPassword(false);
                        setShowForcePasswordChange(false);
                      }}
                      showForcePasswordChange={showForcePasswordChange}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Quote and Video (Desktop only) */}
          {/* <div style={{display:'none'}} className=" laptop:!flex laptop:col-span-6 flex-col justify-end space-y-8 h-[487px] z-[999]">
            <StatsSection count={count} setCount={setCount} />
          </div> */}
        </div>
      </div>
      <Snackbar severity={snackbar.severity} visible={snackbar.visible} message={snackbar.message} />
    </div>
  );
};

export default Login;

/* import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { defaultHandleChange } from "../../utils/handler";
import { DEFAULT_CREDENTIALS } from "../../utils/state";
import { LoginForm } from "../../components/LoginForm";
import { Snackbar } from "../../components/Snackbar";
import { THEME_SEVERITY } from "../../utils/theme";
// import { STRINGS } from "../../utils/strings";
import { useMoodleV2 } from "../../contexts/moodle";
import {
  DEFAULT_SNACKBAR,
  ERROR_CREDENTIALS,
  ERROR_EMPTY_CREDENTIALS,
  SUCCESS_CREDENTIALS,
} from "../../utils/snackbar";

import { useTheme } from "../../contexts/ThemeContext";
import "./styles.css";
import { readableColor } from "polished";
import { useConfig } from "../../contexts/config";

const Login = () => {
  const { config } = useConfig();
  const theme = useTheme();
  const auth = useAuth();
  const navigate = useNavigate();
  const [credentials, setCredentials] = React.useState(DEFAULT_CREDENTIALS);
  const [loading, setLoading] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(DEFAULT_SNACKBAR);
  const [contrastColorSecondary, setcontrastColorSecondary] =
    React.useState("green");
  const [contrastColorPrimary, setcontrastColorPrimary] = React.useState("red");
  const moodlev2 = useMoodleV2();

  React.useEffect(() => {
    //console.log(config);
    document.querySelector("#root").style.backgroundColor = "transparent";
    let bg_img = config.config.theme.background_login;
    document.body.classList.add("imagen2", "bigDesktop:bg-cover");
    // if (localStorage.getItem("token")) navigate("/listcourses");

    if (bg_img) {
      document.body.style.backgroundImage = `url(${bg_img})`;
    }
    return () => {
      document.body.style.backgroundImage = ``;
      document.body.classList.remove(
        "imagen2",
        "bg-auto",
        "bigDesktop:bg-cover"
      );
    };
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    //console.log(theme);
    if (theme && theme.colors.secondary) {
      setcontrastColorSecondary(
        readableColor(theme.colors.secondary_light, "#000", "#fff", false)
      );
    }
    if (theme && theme.colors.primary_light) {
      setcontrastColorPrimary(
        readableColor(theme.colors.primary_light, "#000", "#fff", false)
      );
    }
    // eslint-disable-next-line
  }, [theme]);

  React.useEffect(() => {
    auth.logout(moodlev2);
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    moodlev2.setPageEmbed(null);
  }, [moodlev2]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(credentials).some((value) => value === "");
    if (isEmpty) {
      setSnackbar(ERROR_EMPTY_CREDENTIALS);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
      return;
    }
    let clean_username = credentials.username.replace(/\s/g, "").toLowerCase();
    try {
      setLoading(true);
      await auth.Login({ ...credentials, username: clean_username });
      setSnackbar(SUCCESS_CREDENTIALS);
      setTimeout(() => {
        setLoading(false);
        setSnackbar(DEFAULT_SNACKBAR);
        setCredentials(DEFAULT_CREDENTIALS);
        document.body.classList.remove("imagen3");
        navigate("/listcourses");
      }, 1000);
    } catch (error) {
      console.log(error.message);
      setSnackbar(ERROR_CREDENTIALS);
      setLoading(false);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
    }
  };

  const handleChange = (e) =>
    defaultHandleChange(e, credentials, setCredentials);

  return (
    <>
      <div className="container esp-log ">
        <img
          src="https://par.tuclase.cl/loginalt/images/logo2.png"
          alt="logo"
          className="posi-logo posi-log-b"
          style={{ visibility: "hidden" }}
        />
      </div>

      {theme.colors && theme.colors.themeLoaded && <div className="flex laptop:flex-row flex-col gap-[20%] items-center transition-all">
        <div
          style={{ backgroundColor: theme.colors.backgroundColorHeaderLogin ? theme.colors.backgroundColorHeaderLogin : "#000000" }}
          className=" flex flex-col w-[90%] tablet:w-[37rem] rounded-xl shadow-lg ml-[5%] tablet:ml-[15%] my-8 border-[1px] border-opacity-15 border-zinc-900"
        >
          <div
            style={{ backgroundColor: theme.colors.backgroundColorBodyLogin ? theme.colors.backgroundColorBodyLogin : "#000000" }}
            className="rounded-t-xl h-[19rem] flex flex-col items-center justify-center"
          >
            {config && config.titulo_interfaz && <h2 className="text-4xl font-semibold antialiased text-white tracking-wider pt-4">{config.titulo_interfaz}</h2>}
            <img
              className="logo-login py-8 "
              src={
                theme && theme.mode === "light"
                  ? config.config.theme.theme_logo_dark
                  : config.config.theme.theme_logo_dark
              }
              alt="..."
            />2
          </div>
          <div className="p-8 space-y-8  rounded-lg shadow-md">
            <LoginForm
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              credentials={credentials}
              loading={loading}
              contrastColorSecondary={contrastColorSecondary}
              contrastColorPrimary={contrastColorPrimary}
              theme={theme}
              lang={auth.lang}
            />
          </div>
        </div>
        <div className="hidden laptop:block ml-[5%] tablet:ml-[15%] laptop:ml-0">
          <h1 className="llamado text-4xl tablet:text-5xl laptop:text-8xl">
            Experiencias de <br />
            aprendizaje
          </h1>
          <p className="llamado-d text-2xl tablet:text-3xl laptop:text-4xl">
            a la medida, actualizadas y efectivas
          </p>
        </div>
      </div>}

      <Snackbar
        severity={snackbar.severity}
        visible={snackbar.visible}
        message={snackbar.message}
      />
    </>
  );
};

export default Login;
 */
